import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 24px 16px;
`;

export const Modal = styled.div`
  background: #fff;
  border-radius: 10px;
  width: 100%;
  max-width: 420px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
`;

export const ModalTitle = styled.h2`
  color: #1b2b3a;
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
`;

export const Body = styled.p`
  margin: 0;
  font-size: 0.82rem;
  line-height: 1.55;
  color: #555;
`;

export const CheckRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 4px 0;
`;

export const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  accent-color: #1b6b78;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 1px;
`;

export const CheckLabel = styled.label`
  font-size: 0.82rem;
  color: #333;
  cursor: pointer;
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 6px;
`;

export const CancelButton = styled.button`
  padding: 8px 18px;
  border-radius: 6px;
  border: 1.5px solid #26A9B6;
  background: #fff;
  color: #26A9B6;
  font-size: 0.82rem;
  cursor: pointer;

  &:hover { background: #f0fbfc; }
`;

export const DeleteButton = styled.button`
  padding: 8px 18px;
  border-radius: 6px;
  border: none;
  background: #9E1B32;
  color: #fff;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #851527; }
  &:disabled { opacity: 0.45; cursor: not-allowed; }
`;
